export default __webpack_public_path__ + "static/media/plus.dabaeeb6.svg";